import React from "react"
// import { Link, graphql } from "gatsby"
import { graphql } from "gatsby"
// import Img from "gatsby-image"

import SubscribeForm from '../components/SubscribeForm'
import Testimonials from '../components/Testimonials'
import hardcover from '../images/gtp-hardcover-final.png'
import sarahBio from '../images/sarah-avenir-bio.jpg'
import sarahGroup from '../images/sarah-group.jpg'

import Layout from "../components/layout"
import SEO from "../components/seo"

const BlogIndex = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title
  // const posts = data.allMarkdownRemark.edges

  return (
    <Layout location={location} title={siteTitle} page="landing">
      <SEO title="Gather the People" />

      <section className="main" id="purchase">
        <div className="container">
          <div className="grid-flex-container">
            <div className="grid-flex-cell">
              <img src={hardcover} className="cover" width="300" alt="Gather the People book" />
            </div>
            <div className="grid-flex-cell order-buttons" id="pre-order">
              <a className="button button-pink icon-bookmark" href="pdf/Gather-the-People-2nd-Edition-Pages-PREVIEW.pdf">Read preview</a>
              <a className="button button-outlined-neutral icon-kindle" href="https://andyet.podia.com/gather-the-people-for-kindle-2nd-edition">Buy ebook</a>
              <a className="button button-outlined-neutral icon-course" href="https://andyet.podia.com/gather-the-people-the-course">Buy the self-paced course</a>
            </div>
          </div>
        </div>
      </section>

      <section className="pull-quote">
        <div className="wrapper">
          <blockquote>
            <h3>“Deeply generous. An example of gentleness + ambition—all the loops and cycles it takes to begin, over and over again.”</h3>
            <footer>Diana Kimball Berlin</footer>
          </blockquote>
          <a className="button button-green" href="#testimonials">More people saying stuff</a>
        </div>
      </section>

      <section className="about">
        <div className="wrapper">
          <img src={sarahBio} className="rounded-border" width="160" alt="Sarah Avenir" />
          <h2 className="center">About Me</h2>

          <p><span role="img" aria-label="hand waving">👋</span> Hello! I’m Sarah Avenir. I’m a writer, researcher, and partner and CEO at <a href="http://andyet.com">&amp;yet</a>, a design and software consultancy that’s <a href="http://andyet.com/services">kind of hard to describe</a>. I wrote Gather the People based on a decade of research and personal experience as I’ve tried to figure out how we can get people to care about our work without compromising who we are.</p>

          <p>I love sharing what I’ve learned and working with people to figure out strategies that work for them and their teams. My work has been featured in publications like The Huffington Post, New York Observer, and Offscreen Magazine, and I speak and give workshops at conferences and for organizations like CreativeLive and the University of Pennsylvania.</p>

          <p>If you’d like to learn more, <a href="/pdf/Gather-the-People-2nd-Edition-Pages-PREVIEW.pdf">read the preview</a>! I hope you love it and that it gives you a new vision for what is possible.</p>

          <h4>
            <a href="https://twitter.com/sarahavenir">@sarahavenir</a> | <a href="mailto:sarah@andyet.com">sarah@andyet.com</a>
          </h4>

          <img src={sarahGroup} alt="Sarah taking a selfie with a group of enthusiastic workshop attendees." />

          <blockquote>
            <h5>“It was such a pleasure to have you join our students in Philadelphia last week. What a marvelous contribution your workshop made!”</h5>
            <footer>Debi Spindelman, Center for Social Impact Strategy, University of Pennsylvania</footer>
          </blockquote>
        </div>
      </section>

      <div className="container content-narrower">
        <section id="subscribe">
          <h2 className="center">Can I share what’s next with you?</h2>
          <p>I am currently working on the sequel to <em>Gather the People</em>, which adapts the same principles for teams and organizations. I’m also developing more tools to help you put these principles into practice.</p>

          <p><strong>Sign up for the &yet newsletter</strong> and I’ll let you know when they’re ready. I’ll also send regular but random updates on what I’m thinking and learning. <span role="img" aria-label="finger pointing down">👇</span></p>

          <SubscribeForm mailingListLink="GTPHome" />

        </section>
      </div>

      <Testimonials />

    </Layout>
  )
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
